/* SET STATE */
export const SET_STATE_SERVICE_TYPE = "SET_STATE_SERVICE_TYPE"

/* SERVICE_TYPES */
export const GET_SERVICE_TYPES = "GET_SERVICE_TYPES"
export const GET_SERVICE_TYPES_SUCCESS = "GET_SERVICE_TYPES_SUCCESS"
export const GET_SERVICE_TYPES_FAIL = "GET_SERVICE_TYPES_FAIL"

/* SERVICE_TYPE */
export const GET_SERVICE_TYPE = "GET_SERVICE_TYPE"
export const GET_SERVICE_TYPE_SUCCESS = "GET_SERVICE_TYPE_SUCCESS"
export const GET_SERVICE_TYPE_FAIL = "GET_SERVICE_TYPE_FAIL"

/**
 * ADD SERVICE_TYPE
 */
 export const ADD_NEW_SERVICE_TYPE = "ADD_NEW_SERVICE_TYPE"
 export const ADD_SERVICE_TYPE_SUCCESS = "ADD_SERVICE_TYPE_SUCCESS"
 export const ADD_SERVICE_TYPE_FAIL = "ADD_SERVICE_TYPE_FAIL"

 /**
 * UPDATE SERVICE_TYPE
 */
export const UPDATE_SERVICE_TYPE = "UPDATE_SERVICE_TYPE"
export const UPDATE_SERVICE_TYPE_STATUS = "UPDATE_SERVICE_TYPE_STATUS"
export const UPDATE_SERVICE_TYPE_SUCCESS = "UPDATE_SERVICE_TYPE_SUCCESS"
export const UPDATE_SERVICE_TYPE_FAIL = "UPDATE_SERVICE_TYPE_FAIL"

/**
 * DELETE SERVICE_TYPE
 */
export const DELETE_SERVICE_TYPE = "DELETE_SERVICE_TYPE"
export const DELETE_SERVICE_TYPE_SUCCESS = "DELETE_SERVICE_TYPE_SUCCESS"
export const DELETE_SERVICE_TYPE_FAIL = "DELETE_SERVICE_TYPE_FAIL"
